import React from 'react';
import Grid from '../../common/Grid/Grid';
import ProjectCardItem from './ProjectCardItem';

const ProjectsGrid = ({
  projects,
  isLoading,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  gridRef,
  onView,
  onEdit,
  onManageEmployees,
  onManageCode,
  onDelete,
}) => {
  // Custom renderer for Project items
  const renderProjectItem = ({ item, onClick }) => {
    return <ProjectCardItem
      project={item}
      onClick={onClick}
      onView={onView}
      onEdit={onEdit}
      onManageEmployees={onManageEmployees}
      onManageCode={onManageCode}
      onDelete={onDelete}
    />;
  };

  return (
    <Grid
      items={projects}
      isLoading={isLoading}
      isLoadingMore={false}
      pageInfo={{ hasNextPage: false }}
      renderItem={renderProjectItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={null}
      gridRef={gridRef}
      rowHeight={420}
      emptyStateTitle="No Projects Found"
      emptyStateDescription="No projects found matching the current filters. Try adjusting your search criteria or filters."
      endOfListMessage="You've reached the end of the list"
    />
  );
};

export default ProjectsGrid;
